const styles = (theme) => ({
  paperDatagrid: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    position: "relative",
    overflow: "hidden",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 1,
  },
  titleDatagrid: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    padding: "10px 20px",
    textAlign: "left",
  },
});

export default styles;
